import React, { useEffect, useState } from "react";
import SideBar from "../master/SideBar";
import NavBar from "../master/NavBar";
import { LoadingDiv } from "../../pages/master/Master";
import { AdminBranchList, AdminStudentReport } from "../../api/AdminService";
import {
    PieChart,
    Pie,
    Cell,
    Legend,
    ResponsiveContainer,
    Tooltip,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
} from "recharts";


export default function StudentReport() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [dataBranch, setBranch] = useState();
    const [filters, setFilters] = useState({
        branch_id: "",
        date: new Date().toISOString().split("T")[0],
    });

    const attendanceData = [
        {
            name: "Present",
            value: data?.present_students || 0,
        },
        {
            name: "Absent",
            value: data?.absent_students || 0,
        },
        {
            name: "Not Marked",
            value: data?.not_marked_students || 0,
        },
    ];
    const attendanceColors = [
        "#28a745",
        "#dc3545",
        "#f5ce5b",
    ];

    const messageData = [
        {
            name: "Send",
            value: data?.send_messages || 0,
        },
        {
            name: "Not Send",
            value: data?.not_send_messages || 0,
        },
        {
            name: "Processing",
            value: data?.processing_messages || 0,
        },
        {
            name: "Failed",
            value: data?.failed_messages || 0,
        },
    ];

    const admissionData = [
        {
            name: "Today",
            count: data?.new_admissions?.today || 0,
        },
        {
            name: "This Week",
            count: data?.new_admissions?.this_week || 0,
        },
        {
            name: "This Month",
            count: data?.new_admissions?.this_month || 0,
        },
    ];

    const getReport = async () => {
        try {
            setLoading(true);

            let url = "";

            Object.entries(filters).forEach(([key, value]) => {
                if (value !== "" && value !== null && value !== undefined) {
                    url += `${key}=${encodeURIComponent(value)}&`;
                }
            });

            const response = await AdminStudentReport(url);

            if (response?.data?.status) {
                setData(response.data.data || {});
            }

        } catch (error) {
            console.error("Student Report Error:", error);
        } finally {
            setLoading(false);
        }
    };
    const branchList = async () => {
        try {
            setLoading(true);

            let url = "";

            Object.entries(filters).forEach(([key, value]) => {
                if (value !== "" && value !== null && value !== undefined) {
                    url += `${key}=${encodeURIComponent(value)}&`;
                }
            });

            const response = await AdminBranchList(url);

            if (response?.data?.status) {
                setBranch(response.data.data || {});
            }

        } catch (error) {
            console.error("Student Report Error:", error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        getReport();
        branchList();
    }, [filters]);

    return (
        <>
            {loading && <LoadingDiv />}

            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <SideBar />

                    <div className="layout-page">
                        <NavBar />

                        <div className="content-wrapper">
                            <div className="container-fluid p-4">

                                <div className="card p-3 mb-3 shadow-sm border-0">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center gap-3">
                                            <div
                                                style={{
                                                    width: 45,
                                                    height: 45,
                                                    borderRadius: "12px",
                                                    background:
                                                        "linear-gradient(45deg,#185fa5,#4f8cff)",
                                                    color: "#fff",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <i className="ri-user-3-line"></i>
                                            </div>

                                            <div>
                                                <h5 className="m-0 fw-bold">Student Reports</h5>
                                                <small className="text-muted">
                                                    Student analytics, attendance & admission insights
                                                </small>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center gap-2">

                                            <div className="form-floating form-floating-outline">
                                                <select
                                                    className="form-select"
                                                    value={filters?.branch_id}
                                                    onChange={(e) =>
                                                        setFilters({
                                                            ...filters,
                                                            branch_id: e.target.value,
                                                        })
                                                    }
                                                >
                                                    <option value="">All Branches</option>

                                                    {dataBranch?.map((branch) => (
                                                        <option key={branch.id} value={branch.id}>
                                                            {branch.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label>Branch</label>
                                            </div>

                                            <div className="form-floating form-floating-outline">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={filters?.date}
                                                    onChange={(e) =>
                                                        setFilters({
                                                            ...filters,
                                                            date: e.target.value,
                                                        })
                                                    }
                                                />
                                                <label>Date</label>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <div className="card-body">


                                    <div className="row g-3">

                                        <div className="col-md-3">
                                            <div className="simple-card border-primary">
                                                <small className="text-muted fw-bold">
                                                    All Students
                                                </small>
                                                <h4 className="text-primary m-0">
                                                    {data?.all_students || 0}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="simple-card border-success">
                                                <small className="text-muted fw-bold">
                                                    Active Students
                                                </small>
                                                <h4 className="text-success m-0">
                                                    {data?.active_students || 0}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="simple-card border-warning">
                                                <small className="text-muted fw-bold">
                                                    Inactive Students
                                                </small>
                                                <h4 className="text-warning m-0">
                                                    {data?.inactive_students || 0}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="simple-card border-info">
                                                <small className="text-muted fw-bold">
                                                    Complete Students
                                                </small>
                                                <h4 className="text-info m-0">
                                                    {data?.complete_students || 0}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="simple-card border-danger">
                                                <small className="text-muted fw-bold">
                                                    Left Students
                                                </small>
                                                <h4 className="text-danger m-0">
                                                    {data?.left_students || 0}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="simple-card border-secondary">
                                                <small className="text-muted fw-bold">
                                                    RTE Students
                                                </small>
                                                <h4 className="text-secondary m-0">
                                                    {data?.rte_students || 0}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="simple-card border-dark">
                                                <small className="text-muted fw-bold">
                                                    Transport Students
                                                </small>
                                                <h4 className="text-dark m-0">
                                                    {data?.transport_students || 0}
                                                </h4>
                                            </div>
                                        </div>

                                    </div>
                                </div>



                                <div className="row g-4 mt-2">

                                    {/* Attendance */}
                                    <div className="col-lg-6">
                                        <div className="card shadow-sm h-100">
                                            <div className="card-header">
                                                <h5 className="mb-0">Attendance Graph</h5>
                                            </div>

                                            <div className="card-body">
                                                <ResponsiveContainer width="100%" height={350}>
                                                    <PieChart>
                                                        <Pie
                                                            data={attendanceData}
                                                            dataKey="value"
                                                            cx="50%"
                                                            cy="50%"
                                                            outerRadius={110}
                                                            label
                                                        >
                                                            {attendanceData.map((entry, index) => (
                                                                <Cell
                                                                    key={index}
                                                                    fill={attendanceColors[index]}
                                                                />
                                                            ))}
                                                        </Pie>

                                                        <Tooltip />
                                                        <Legend />
                                                    </PieChart>
                                                </ResponsiveContainer>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Messages */}
                                    <div className="col-lg-6">
                                        <div className="card shadow-sm h-100">
                                            <div className="card-header">
                                                <h5 className="mb-0">Message Status</h5>
                                            </div>

                                            <div className="card-body">
                                                <ResponsiveContainer width="100%" height={350}>
                                                    <BarChart data={messageData}>
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="name" />
                                                        <YAxis />
                                                        <Tooltip
                                                            cursor={{ fill: "transparent" }}
                                                        />

                                                        <Bar dataKey="value" fill="#0d6efd" radius={[6, 6, 0, 0]} barSize={30}
                                                        />
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Admissions */}
                                    <div className="col-6">
                                        <div className="card shadow-sm">
                                            <div className="card-header">
                                                <h5 className="mb-0">New Admissions Trend</h5>
                                            </div>

                                            <div className="card-body">
                                                <ResponsiveContainer width="100%" height={350}>
                                                    <BarChart data={admissionData}>
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="name" />
                                                        <YAxis />
                                                        <Tooltip
                                                            cursor={{ fill: "transparent" }}
                                                        />

                                                        <Bar
                                                            dataKey="count"
                                                            fill="#198754"
                                                            radius={[6, 6, 0, 0]}
                                                            barSize={50}


                                                        />
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}